import { FetchPatientData } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function fetchPatientData(mode, type,jsonData) {
  try {
    const payload = {mode,type, jsonData}
    const res = await getCharts(FetchPatientData, payload)
    return res.data
  } catch (error) {
    return error
  }
}
